// @flow
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { GeneralModalForm, LoadingProgress, SnackbarMessage, NoItem, AppHeader } from "imagus-components";
import CreateProjectFormRedux from "./CreateProjectFormRedux";
import ProjectList from "../../components/projects/ProjectList";
import { buildProjectItemJson } from "../../components/projects/buildProjectJson";
import { fetcProjectList } from "../../actions/projectActions";
import { companyDialogMessages } from "../../components/companies/CompileCompanytoJson";
import { propComparator } from "../../../global/functions/StringOperations";
import { hasPrincipal } from "../../../global/containers/UserAuth";

import Button from "@material-ui/core/Button";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";

type MyProjectStateType = {
  messageId: number,
  projectId: string,
  modalOpen: boolean,
  snackOpen: boolean
};

class MyProject extends Component<*, MyProjectStateType> {
  constructor(props) {
    super(props);
    this.state = {
      messageId: 0,
      projectId: props.match.params.token ? props.match.params.token : "",
      modalOpen: false,
      snackOpen: false
    };
  }

  componentDidMount() {
    this.props.actions.fetcProjectList();
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  openSnackbar = (messageId: number): * => {
    this.setState(
      { messageId: messageId },
      this.switchModalStatus("snackOpen")(true)
    );
  };

  render(): * {
    const projects = this.props.projects;
    let projectNode = null;
    if (projects) {
      projects
        .sort(propComparator("auditCreationDate", false, null, null, true))
        .reverse();
      if (projects.length === 0) {
        projectNode = <NoItem content="No Project has created yet." />;
      } else {
        let projectList = [];
        for (let i = 0; i < projects.length; i++) {
          projectList.push(buildProjectItemJson(projects[i]));
        }
        projectNode = (
          <ProjectList
            projects={projectList}
            currentCompany={this.props.user && this.props.user.company}
            openSnackbar={this.openSnackbar}
            preLoadId={this.state.projectId}
            canViewQuotes={hasPrincipal(
              "billing",
              this.props.user.groups
            )}
          />
        );
      }
    }
    if (!projectNode) {
      return <LoadingProgress />;
    } else {
      return (
        <Fragment>
          <AppHeader
            title="My Projects"
            actions={[
              <Button
                type="button"
                variant="contained"
                color="primary"
                className="dark-btn"
                onClick={(): Function =>
                  this.switchModalStatus("modalOpen")(true)
                }
              >
                <LibraryAddIcon className="light-icon right-margin-5" />
                Create Project
              </Button>
            ]}
          />
          <GeneralModalForm
            title="Create Project"
            open={this.state.modalOpen}
            handleModalStatus={this.switchModalStatus("modalOpen")}
            form={
              <CreateProjectFormRedux
                onClose={(): Function =>
                  this.switchModalStatus("modalOpen")(false)
                }
                maxWidth
              />
            }
          />
          <div className="app-panel">
            <SnackbarMessage
              open={this.state.snackOpen}
              handleModalStatus={this.switchModalStatus("snackOpen")}
              message={companyDialogMessages[this.state.messageId]}
            />
            {projectNode}
          </div>
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  projects: state.v3account.project.projects,
  user: state.v3account.user
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetcProjectList }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyProject);
